import { render } from "./AsahiRadioButton.vue?vue&type=template&id=a264b1d2&scoped=true"
import script from "./AsahiRadioButton.vue?vue&type=script&lang=js"
export * from "./AsahiRadioButton.vue?vue&type=script&lang=js"

import "./AsahiRadioButton.vue?vue&type=style&index=0&id=a264b1d2&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a264b1d2"]])

export default __exports__